import { PhotoContextProvider } from '@jotta/photos/provider'
import { ErrorPage } from '@jotta/ui/ErrorPage'
import { LoadingOverlay } from '@jotta/ui/LoadingOverlay'
import { env } from '@jotta/utils/env'
import { ErrorBoundary } from '@sentry/react'
import { Suspense } from 'react'
import { Outlet, useLoaderData } from 'react-router-dom'
import { ThemeSwitcher } from '../ThemeSwitcher'
import type { rootLoader } from './rootLoader'
import { useTracking } from './useTracking'

export function Root() {
  useTracking()

  const { redirectToAutoLogin } = useLoaderData() as Awaited<
    ReturnType<typeof rootLoader>
  >
  return (
    <ErrorBoundary
      fallback={({ error, resetError }) => (
        <ErrorPage error={error} resetError={resetError} />
      )}
      beforeCapture={scope =>
        scope
          .setExtra('dimensions', {
            width: window.innerWidth,
            height: window.innerHeight,
          })
          .setTag('section', 'root')
      }
    >
      <PhotoContextProvider>
        <Suspense fallback={<LoadingOverlay open />}>
          {redirectToAutoLogin ? <LoadingOverlay open /> : <Outlet />}
          {process.env.NODE_ENV === 'development' &&
            env.activeBrands.length > 1 && <ThemeSwitcher />}
        </Suspense>
      </PhotoContextProvider>
    </ErrorBoundary>
  )
}
